import React from 'react';

interface DirectoryLettersProps {
  selectedLetter: string;
  onLetterSelect: (letter: string) => void;
  availableLetters?: string[];
}

const DirectoryLetters: React.FC<DirectoryLettersProps> = ({
  selectedLetter,
  onLetterSelect,
  availableLetters
}) => {
  // Use provided available letters or fall back to full alphabet
  const allLetters = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    '#'
  ];

  const letters = availableLetters || allLetters;

  const getLetterButtonClasses = (
    isSelected: boolean,
    isAvailable: boolean
  ): string => {
    let classes = 'z-10 w-8 h-8 flex items-center justify-center text-sm font-medium rounded-md transition-transform active:scale-85';
    
    if (isSelected) {
      classes += ' text-black font-semibold relative after:absolute after:left-0 after:-bottom-[1px] after:w-[100%] after:h-[2px] after:bg-black';
    } else if (isAvailable) {
      classes += ' text-gray-700 hover:text-gray-900';
    } else {
      classes += ' text-gray-300 cursor-not-allowed';
    }
    
    return classes;
  };

  const handleLetterClick = (letter: string) => {
    // If the same letter is clicked, toggle it off (unselect)
    if (selectedLetter === letter) {
      onLetterSelect('');
    } else {
      onLetterSelect(letter);
    }
  };

  return (
    <div className="flex flex-wrap md:grid w-full mb-6 gap-1 md:gap-2 justify-center md:justify-between justify-items-center [grid-template-columns:repeat(auto-fit,minmax(2rem,2rem))] md:[grid-template-columns:repeat(auto-fit,minmax(2rem,1fr))]">
      {allLetters.map((letter) => {
        const isAvailable = !availableLetters || letters.includes(letter);
        const isSelected = selectedLetter === letter;

        return (
          <button
            type="button"
            key={letter}
            onClick={() => handleLetterClick(letter)}
            disabled={!isAvailable}
            className={getLetterButtonClasses(isSelected, isAvailable)}
          >
            {letter}
          </button>
        );
      })}
    </div>
  );
};

export default DirectoryLetters;
